import React, {useEffect, useState} from 'react';
import {
    Grid, TextField
} from '@material-ui/core';
import {useTranslation} from "react-i18next";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {format} from "date-fns";
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import {DateRangeFilter} from "../../../components/DateRangeFilter";

const Filter = ({filter, onUpdateFilter, sort, onFilterChangedHandler, onSortChangedHandler}) => {

    const { t }  = useTranslation();
	const [parkingZones, setParkingZones] = useState([]);
	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

    useEffect(async () => {
        const parkingZoneRepository = new ParkingZoneRepository();
        const result = await parkingZoneRepository.getSelector();
        setParkingZones(result.data);
    }, []);

	return (
            <Grid>
              <FilterBar showQuerySearch={true} sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort}>
                  <Grid item xs={2}>
                      <DateRangeFilter value={filter.DateFrom && filter.DateTo ? { startDate: new Date(filter.DateFrom), endDate: new Date(filter.DateTo) } : null} onChange={e => { onUpdateFilter(null, { 'DateFrom': format(e.startDate, 'yyyy-MM-dd'), 'DateTo': format(e.endDate, 'yyyy-MM-dd') }); }} />
                   </Grid>
                <Grid item xs={2}>

                  <TextField
                        label={t('Parking zone')}
                        select
                        fullWidth
                        SelectProps={{ native: true }}
                        defaultValue={""}
                        onChange={e => onUpdateFilter('ParkingZoneId', e.target.value)}
                  >
                      <option></option>
                    {parkingZones.map((item) => (
                      <option
                        key={item.Id}
                        value={item.Id}
                      >
                        {item.Name}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </FilterBar>
           </Grid>
	);
};

export default Filter;